import { FC } from "react";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { DiscountDetailsCard, Instructions } from "../components";
import DiscountChips from "../components/DiscountChips/DiscountChips";
import DiscountRedeemBar from "../components/DiscountRedeemBar/DiscountRedeemBar";

type Props = {
  data: DiscountItemType | undefined;
  imageUrl: string | undefined;
  itemCode?: string;
  items: DiscountItemType[];
  selectedItemIndex: number;
  setSelectedItemIndex: (i: number) => void;
  brandName?: string;
};

const DiscountsDetailsMob: FC<Props> = ({ data, imageUrl, itemCode, items, selectedItemIndex, setSelectedItemIndex, brandName }) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="rounded-xs outline-border-subtle flex flex-col overflow-hidden outline">
        <div className="p-4">
          <DiscountDetailsCard data={data} imageUrl={imageUrl} brandName={brandName} />
        </div>
        {items.length > 1 && (
          <div className="p-4">
            <DiscountChips items={items} selectedItemIndex={selectedItemIndex} onSelect={setSelectedItemIndex} />
          </div>
        )}
      </div>
      <Instructions termsAndConditions={data?.termsAndConditions ?? ""} usageInstructions={data?.usageInstructions ?? ""} />
      <div className="shadow-bottom-sheet bg-background-default fixed start-0 end-0 bottom-0 z-50 rounded-t-xl p-4">
        <DiscountRedeemBar data={data} imageUrl={imageUrl} itemCode={itemCode} />
      </div>
    </div>
  );
};

export default DiscountsDetailsMob;
